import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { RoleProvider } from "./lib/roles.jsx";
import Layout from "./components/Layout";
import Overview from "./pages/Overview";
import Workbench from "./pages/Workbench";
import CaseDetail from "./pages/CaseDetail";
import Portfolio from "./pages/Portfolio";
import Diagnostics from "./pages/Diagnostics";
import PublicReceipt from "./pages/PublicReceipt";

function Shell({ children }) {
    return <Layout>{children}</Layout>;
}

export default function App() {
    return (
        <RoleProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Shell><Overview /></Shell>} />
                    <Route path="/workbench" element={<Shell><Workbench /></Shell>} />
                    <Route path="/case/:id" element={<Shell><CaseDetail /></Shell>} />
                    <Route path="/portfolio" element={<Shell><Portfolio /></Shell>} />
                    <Route path="/diagnostics" element={<Shell><Diagnostics /></Shell>} />
                    <Route path="/r/:hash" element={<PublicReceipt />} />
                    <Route path="/receipt/:hash" element={<RedirectToPublic />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </RoleProvider>
    );
}

function RedirectToPublic() {
    // Redirect /receipt/:hash -> /r/:hash to honour the canonical public route.
    const hash = window.location.pathname.split("/").pop();
    return <Navigate to={`/r/${hash}`} replace />;
}
